import { createFileRoute } from '@tanstack/react-router';
import { useRealmAuthStore as realmAuthStore } from '@interxfi/api-client';
import { TenantContext } from '@interxfi/api-client/realm-context';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { USERAUTH_ORGANIZATION_BASE_PATH } from '../../../../../features/userauth/organization/userauth-organization-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/organization/_organization')({
  loader: () => {
    const initialState = realmAuthStore.getState();

    if (initialState.activeAccess?.tenant?.tenantType !== TenantContext.Platform) {
      return;
    }

    return {
      breadcrumb: buildBreadcrumb({
        id: 'organization-index',
        label: 'Organizations',
        to: USERAUTH_ORGANIZATION_BASE_PATH,
      }),
    } satisfies AggregateBreadcrumb;
  },
  loaderDeps: () => [realmAuthStore.getState().activeAccess?.tenant?.tenantType === TenantContext.Platform],
});
